import client from '../client';
import endpoints from '../endpoints';

/* ── 서비스 (유저용) ── */

/** GET /api/reservations — 내 예약 목록 */
export const getReservations = async (params = {}) => {
  const res = await client.get(endpoints.reservations.list, { params });
  return res.data;
};

/** GET /api/reservations/lookup — 예약번호 조회 (비회원) */
export const lookupReservation = async (params) => {
  const res = await client.get(endpoints.reservations.lookup, { params });
  return res.data;
};

/** GET /api/reservations/:id — 예약 상세
 *  BugHerd #193: 비회원 게스트 조회 시 옵션으로 verified email 전달 가능.
 *  BE 가 booker_email 매칭 시 회원 예약도 비로그인 조회 허용.
 */
export const getReservationById = async (id, { email } = {}) => {
  const params = email ? { email } : undefined;
  const res = await client.get(endpoints.reservations.detail(id), { params });
  return res.data;
};

/** GET /api/reservations/:id/receipt-url — 결제 영수증(포트원 매출전표) URL. 없으면 receipt_url=null */
export const getReservationReceiptUrl = async (id, { email } = {}) => {
  const params = email ? { email } : undefined;
  const res = await client.get(endpoints.reservations.receiptUrl(id), { params });
  return res.data;
};

/** POST /api/reservations — 예약 생성 */
export const createReservation = async (body) => {
  const res = await client.post(endpoints.reservations.create, body);
  return res.data;
};

/** PUT /api/reservations/:id/cancel — 예약 취소 */
export const cancelReservation = async (id) => {
  const res = await client.put(endpoints.reservations.cancel(id));
  return res.data;
};

/** POST /api/reservations/:id/rebook — 재예약 */
export const rebookReservation = async (id) => {
  const res = await client.post(endpoints.reservations.rebook(id));
  return res.data;
};

/** GET /api/availability/check — 예약 가용성 체크 */
export const checkAvailability = async (params) => {
  const res = await client.get('/api/availability/check', { params });
  return res.data;
};

/* ── 관리자 (Admin) ── */

/** GET /api/admin/reservations — 전체 예약 목록 (페이지네이션) */
export const getAdminReservations = async (params = {}) => {
  const res = await client.get(endpoints.admin.reservations.list, { params });
  return res.data;
};

/** GET /api/admin/reservations/:id — 관리자 예약 상세 */
export const getAdminReservationById = async (id) => {
  const res = await client.get(endpoints.admin.reservations.detail(id));
  return res.data;
};

/** PUT /api/admin/reservations/:id/status — 상태 변경 */
export const updateAdminReservationStatus = async (id, status, extraData) => {
  const res = await client.put(endpoints.admin.reservations.status(id), { status, ...extraData });
  return res.data;
};

/** PUT /api/admin/reservations/:id/memo — 메모 수정 */
export const updateAdminReservationMemo = async (id, memo) => {
  const res = await client.put(endpoints.admin.reservations.memo(id), { memo });
  return res.data;
};

/** PUT /api/admin/reservations/:id/driver-info — 기사 연락처·차량번호 입력 (출발지 도착 알림용) */
export const updateAdminReservationDriverInfo = async (id, { driverPhone, vehicleNumber }) => {
  const res = await client.put(endpoints.admin.reservations.driverInfo(id), {
    driver_phone: driverPhone,
    vehicle_number: vehicleNumber,
  });
  return res.data;
};

/** POST /api/admin/reservations/:id/extra-charge — 추가 요금 청구 */
export const createAdminExtraCharge = async (id, data) => {
  const res = await client.post(endpoints.admin.reservations.extraCharge(id), data);
  return res.data;
};

/** POST /api/admin/reservations/:id/unblock — 버퍼 수동 해제 */
export const unblockReservation = async (id) => {
  const res = await client.post(endpoints.admin.reservations.unblock(id));
  return res.data;
};

/** PUT /api/admin/reservations/:id/buffer-after — 운행 완료 후 buffer_after 분 실시간 조절 (BugHerd #37) */
export const updateAdminReservationBufferAfter = async (id, minutes) => {
  const res = await client.put(endpoints.admin.reservations.bufferAfter(id), { minutes });
  return res.data;
};
